<script setup lang="ts">
  import { BottomSheet, Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import { ref } from 'vue';
  import { NightsRangeSlider } from '@/features/searchForm/nightsRange';
  import MobilePrimaryButton from '@/shared/ui/MobilePrimaryButton.vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';

  const flow = useMobileSearchFlowContext();

  const bottomSheetRef = ref<null | { close: () => Promise<void> }>(null);

  const onNext = async () => {
    await bottomSheetRef.value?.close();
  };
</script>

<template>
  <BottomSheet
    ref="bottomSheetRef"
    root-class="mobile-nights-sheet"
    :animated="true"
    :icon-closable="true"
    @close="flow.closeNights"
  >
    <template #header>
      <Typo
        :variant="TypoVariant.Heading6"
        class="mobile-nights-sheet__typo"
        tag="span"
      >
        {{ flow.texts.labels.nights }}
      </Typo>
    </template>

    <div
      class="mobile-nights-sheet__body"
      data-testid="search-form-mobile-nights"
      @touchmove.stop
    >
      <NightsRangeSlider
        :model-value="flow.nights.value"
        @update:modelValue="flow.updateNights"
        @manual="flow.onManualNights"
      />
    </div>

    <template #footer>
      <MobilePrimaryButton
        testid="search-form-mobile-nights-next"
        @click="onNext"
      >
        {{ flow.primaryTexts.next }}
      </MobilePrimaryButton>
    </template>
  </BottomSheet>
</template>

<style>
  .mobile-nights-sheet .tl-bottom-sheet__footer {
    padding-top: 0;
  }
</style>

<style scoped lang="scss">
  .mobile-nights-sheet {
    &__body {
      box-sizing: border-box;
      padding-bottom: var(--spacing-l);
      width: 100%;
    }

    &__typo {
      padding-top: var(--spacing-xxs);
      text-align: center;
      width: 100%;
    }
  }
</style>
